import { useEditor } from 'components/VisualStudioPlayground/VisualEditorContext'
import {
  CornerRoundingStyle,
  ShadowStyle,
  StrokeColorStyle,
  StrokeWidthStyle,
  TextBoxBackgroundFillStyle,
  TextBoxBackgroundShapeStyle,
} from 'components/VisualStudioPlayground/VisualEditor/StyleProps'
import { track } from '@tldraw/tldraw'
import { useRelevantStyles } from 'components/VisualStudioPlayground/VisualEditor/hooks/useRelevantStyles'
import Styles from '../ShapesTab.module.scss'
import { Border } from './Border'
import { Shadow } from './Shadow'
import { Opacity } from './Opacity'
import { ColorRow } from './ColorRow'
import { useFlipperFlag } from 'hooks/useFlipperFlag'
import { Replaceable } from './Replaceable'
import { ImageShape } from 'components/VisualStudioPlayground/Shapes/ImageShape/Types'
import { BackgroundToggle } from './BackgroundToggle'
import { CutoutToggle } from './CutoutToggle'
import { CornerRounding } from './CornerRounding'
import { AutoUpdatableToggle } from './AutoUpdatableToggle'
import { VideoShape } from 'components/VisualStudioPlayground/Shapes/VideoShape/Types'
import { GeoShape } from 'components/VisualStudioPlayground/Shapes/GeoShape/Types'
import { TextBoxShape } from 'components/VisualStudioPlayground/Shapes/TextBoxShape/Types'
import { MaskShape } from 'components/VisualStudioPlayground/Shapes/MaskShape/Types'
import { FrameShape } from 'components/VisualStudioPlayground/Shapes/FrameShape/Types'
import { TextBoxBackground } from './TextBoxBackground'

const ColorToolsCard = track(() => {
  const editor = useEditor()
  const selectedShape = editor.getOnlySelectedShape()
  const relevantStyles = useRelevantStyles(editor)
  const canAccessAdminTemplates = useFlipperFlag('admin_templates')

  if (!editor || !selectedShape || !relevantStyles) return null

  const { styles, opacity } = relevantStyles

  const strokeWidth = styles.get(StrokeWidthStyle)
  const cornerRoundingStyle = styles.get(CornerRoundingStyle)
  const strokeColorStyle = styles.get(StrokeColorStyle)
  const shadow = styles.get(ShadowStyle)
  const textBoxBackgroundFill = styles.get(TextBoxBackgroundFillStyle)
  const textBoxBackgroundShape = styles.get(TextBoxBackgroundShapeStyle)

  return (
    <div className={Styles.card}>
      <ColorRow editor={editor} />
      {textBoxBackgroundFill && textBoxBackgroundShape && (
        <TextBoxBackground editor={editor} fillStyle={textBoxBackgroundFill} shapeStyle={textBoxBackgroundShape} />
      )}
      {strokeWidth && <Border editor={editor} style={strokeWidth} strokeColorStyle={strokeColorStyle} />}
      {cornerRoundingStyle && <CornerRounding editor={editor} style={cornerRoundingStyle} />}
      {shadow && <Shadow editor={editor} style={shadow} />}
      {opacity && opacity.type === 'shared' && selectedShape.type !== 'video' && (
        <Opacity editor={editor} style={opacity} />
      )}
      {selectedShape.type === 'image' && (
        <>
          <CutoutToggle key="cutout" editor={editor} shape={selectedShape as ImageShape} />
          {canAccessAdminTemplates && (
            <BackgroundToggle key="background" editor={editor} shape={selectedShape as ImageShape} />
          )}
        </>
      )}
      {['image', 'mask', 'video'].includes(selectedShape.type) && canAccessAdminTemplates && (
        <Replaceable key="replaceable" editor={editor} shape={selectedShape as ImageShape} />
      )}
      {canAccessAdminTemplates && selectedShape && (
        <AutoUpdatableToggle
          editor={editor}
          shape={selectedShape as ImageShape | VideoShape | GeoShape | TextBoxShape | MaskShape | FrameShape}
        />
      )}
    </div>
  )
})

export { ColorToolsCard }
